import { render } from "./DrawerContentsList.vue?vue&type=template&id=4657ed40"
import script from "./DrawerContentsList.vue?vue&type=script&lang=js"
export * from "./DrawerContentsList.vue?vue&type=script&lang=js"

import "./DrawerContentsList.vue?vue&type=style&index=0&id=4657ed40&lang=scss"

import exportComponent from "/builds/lindner/lindner-factorytour-frontend-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__